const syncSellingPlansForSelection = componentKey => {
  if (
    !componentKey ||
    !window.bundleSelections ||
    !window.bundleSellingPlansData ||
    !window.bundleSellingPlansData.products
  ) {
    return;
  }

  const selection = window.bundleSelections[componentKey];
  if (!selection || !selection.productId) {
    return;
  }

  const productKey = String(selection.productId);
  const productEntry = window.bundleSellingPlansData.products[productKey];

  if (productEntry && productEntry.selling_plans) {
    selection.sellingPlans = productEntry.selling_plans;
  } else if (selection.sellingPlans) {
    delete selection.sellingPlans;
  }
};

const parsePriceCents = (value) => {
  const intValue = parseInt(value, 10);
  return Number.isNaN(intValue) ? 0 : intValue;
};

const getSelectedPlanDiscountPercent = () => {
  const subscriptionSelect = document.querySelector('.subscription-total__dropdown select');
  if (!subscriptionSelect) return 0;

  const selectedOption = subscriptionSelect.selectedOptions && subscriptionSelect.selectedOptions[0];
  if (!selectedOption) return 0;

  const discountAttr = selectedOption.dataset.discountPercent;
  const discountValue = discountAttr !== undefined ? parseFloat(discountAttr) : 0;
  return Number.isNaN(discountValue) ? 0 : discountValue;
};

const applyDiscount = (amountCents, discountPercent) => {
  if (!discountPercent || discountPercent <= 0) return amountCents;
  const multiplier = (100 - discountPercent) / 100;
  return Math.round(amountCents * multiplier);
};

document.addEventListener('DOMContentLoaded', () => {
  const dropdowns = document.querySelectorAll('.bundle-dropdown');

  if (!dropdowns.length) {
    return;
  }

  window.bundleSelections = window.bundleSelections || {};

  const bundleDropdownKeys = [];

  const closeAllDropdowns = (except = null) => {
    dropdowns.forEach(dropdown => {
      if (dropdown !== except) {
        dropdown.classList.remove('active');
      }
    });
  };

  const computeSelectionSnapshot = () => {
    const selections = {};
    bundleDropdownKeys.forEach(key => {
      if (window.bundleSelections[key]) {
        selections[key] = { ...window.bundleSelections[key] };
      }
    });

    const missingComponents = bundleDropdownKeys.filter(key => {
      const selection = window.bundleSelections[key];
      return !selection || !selection.variantId;
    });

    const purchaseType = window.bundlePurchaseType || 'subscribe';
    const planName = purchaseType === 'subscribe' ? (window.selectedBundlePlan || '') : '';

    const selectionValues = bundleDropdownKeys
      .map(key => window.bundleSelections[key])
      .filter(Boolean);

    let subtotal = 0;
    let compareSubtotal = 0;

    if (selectionValues.length) {
      selectionValues.forEach(selection => {
        const price = parsePriceCents(selection.price);
        const comparePrice = selection.compareAtPrice && selection.compareAtPrice > 0
          ? parsePriceCents(selection.compareAtPrice)
          : price;

        subtotal += price;
        compareSubtotal += comparePrice;
      });
    } else {
      const initialPrice = parsePriceCents(window.bundleInitialPriceCents);
      const initialCompare = parsePriceCents(window.bundleInitialCompareAtPriceCents);
      subtotal = initialPrice;
      compareSubtotal = initialCompare > 0 ? initialCompare : initialPrice;
    }

    const planDiscountPercent = purchaseType === 'subscribe' ? getSelectedPlanDiscountPercent() : 0;
    const discountedTotal = purchaseType === 'subscribe'
      ? applyDiscount(subtotal, planDiscountPercent)
      : subtotal;

    const isComplete = missingComponents.length === 0;

    const hasDiscount = purchaseType === 'subscribe'
      ? discountedTotal < subtotal
      : compareSubtotal > subtotal;

    const displaySubtotal = isComplete ? subtotal : 0;
    const displayCompareSubtotal = isComplete ? compareSubtotal : 0;
    const displayDiscountedTotal = isComplete ? discountedTotal : 0;

    return {
      selections,
      planName,
      isComplete,
      missingComponents,
      purchaseType,
      subtotal,
      compareSubtotal,
      discountedTotal,
      discountPercent: planDiscountPercent,
      hasDiscount,
      displaySubtotal,
      displayCompareSubtotal,
      displayDiscountedTotal
    };
  };

  window.getBundleSelectionState = () => computeSelectionSnapshot();

  window.recalculateBundleTotals = () => {
    const snapshot = computeSelectionSnapshot();
    window.currentBundleTotals = snapshot;
    document.dispatchEvent(new CustomEvent('bundle:totals-changed', { detail: snapshot }));
    return snapshot;
  };

  dropdowns.forEach(dropdown => {
    const componentKey = dropdown.dataset.componentKey;
    const defaultQuantityRaw = parseInt(dropdown.dataset.defaultQuantity, 10);
    const defaultQuantity = Number.isNaN(defaultQuantityRaw) ? 1 : defaultQuantityRaw;
    const componentTitle = dropdown.dataset.componentTitle || '';

    const header = dropdown.querySelector('.bundle-dropdown__header');
    const toggleButton = dropdown.querySelector('.bundle-dropdown__toggle');
    const emptySummary = dropdown.querySelector('.bundle-dropdown__summary--empty');
    const filledSummary = dropdown.querySelector('.bundle-dropdown__summary--filled');
    const filledTitle = dropdown.querySelector('.bundle-dropdown__title');
    const filledFlavor = dropdown.querySelector('.bundle-dropdown__flavor');
    const filledImage = dropdown.querySelector('.bundle-dropdown__image');
    const keyFromHeader = header?.dataset.componentHandle || dropdown.dataset.componentKey;
    const effectiveComponentKey = keyFromHeader || componentKey;

    if (effectiveComponentKey) {
      bundleDropdownKeys.push(effectiveComponentKey);
    }

    if (!header || !emptySummary || !filledSummary || !effectiveComponentKey) {
      return;
    }

    const toggleDropdown = event => {
      event.preventDefault();
      const isActive = dropdown.classList.contains('active');
      closeAllDropdowns(isActive ? dropdown : null);
      dropdown.classList.toggle('active', !isActive);
    };

    header.addEventListener('click', toggleDropdown);

    if (toggleButton) {
      toggleButton.addEventListener('click', event => {
        event.stopPropagation();
        toggleDropdown(event);
      });
    }

    dropdown.querySelectorAll('.bundle-item').forEach(item => {
      item.addEventListener('click', () => {

        dropdown.querySelectorAll('.bundle-item').forEach(entry => entry.classList.remove('selected'));
        item.classList.add('selected');

        const productTitle = item.dataset.productTitle || '';
        const productHandle = item.dataset.productHandle || '';
        const variantTitle = item.dataset.variantTitle || '';
        const imageSrc = item.dataset.image || '';
        const productId = item.dataset.productId;
        const variantId = item.dataset.variantId;
        const priceCents = parsePriceCents(item.dataset.price);
        const compareAtPriceCents = item.dataset.compareAtPrice
          ? parsePriceCents(item.dataset.compareAtPrice)
          : priceCents;

        dropdown.classList.remove('bundle-dropdown--error');

        if (filledTitle) {
          filledTitle.textContent = productTitle;
        }
        if (filledFlavor) {
          filledFlavor.textContent = variantTitle;
        }
        if (filledImage && imageSrc) {
          filledImage.src = imageSrc;
          filledImage.alt = variantTitle || productTitle;
        }

        emptySummary.classList.add('is-hidden');
        filledSummary.classList.remove('is-hidden');

        // Ensure consistent bundle ID across all bundle selections
        const consistentBundleId = window.bundleId || `bundle_${Date.now()}_${Math.random().toString(36).substring(2, 11)}`;

        // Update window.bundleId if it was empty so all selections use the same ID
        if (!window.bundleId) {
          window.bundleId = consistentBundleId;
        }

        window.bundleSelections[effectiveComponentKey] = {
          productId,
          productHandle,
          variantId,
          productTitle,
          variantTitle,
          variantImage: imageSrc,
          componentKey: effectiveComponentKey,
          quantity: defaultQuantity,
          componentTitle,
          price: priceCents,
          compareAtPrice: compareAtPriceCents,
          bundleId: consistentBundleId
        };

        // Persist available selling plan IDs alongside the variant selection.
        syncSellingPlansForSelection(effectiveComponentKey);

        dropdown.classList.remove('active');

        if (typeof window.recalculateBundleTotals === 'function') {
          const totals = window.recalculateBundleTotals();
        }

        // Emit custom event for comparison table to listen
        const selectionValues = Object.values(window.bundleSelections).filter(Boolean);
        const bundleSelectionEvent = new CustomEvent('bundle:selection-changed', {
          detail: {
            selections: window.bundleSelections,
            selectionValues: selectionValues,
            componentKey: effectiveComponentKey,
            selectedProduct: {
              productId,
              productHandle,
              variantId,
              productTitle,
              variantTitle
            }
          }
        });
        document.dispatchEvent(bundleSelectionEvent);
      });
    });
  });

  if (typeof window.recalculateBundleTotals === 'function') {
    window.recalculateBundleTotals();
  }
});
